const Globals = {
  blogURI: "news",
}

module.exports = Globals
